import React, { useContext } from 'react';
import Tabs from './Tabs';
import Tab from './Tab';
import TabAdd from './TabAdd';
import TabBar from './TabBar';
import WindowButtons from './WindowButtons';
import WindowButton from './WindowButton';

function Header() {
  return (
    <div className="window__header">
      <WindowButtons>
        <WindowButton type="close"></WindowButton>
        <WindowButton type="minimize"></WindowButton>
        <WindowButton type="maximize"></WindowButton>
      </WindowButtons>
      <Tabs>
        <Tab id="first" />
        <Tab id="second" />
        <TabAdd />
      </Tabs>
      <TabBar />
    </div>
  );
}

export default Header;
